import ChevronRightSvg from '../../assets/icons/chevron_right.svg'

const Input = ({ ...inputProps }) => {
  return (
    <div className="relative w-full rounded-full overflow-hidden">
      <input className="w-full py-2 px-3 pr-8 border border-red-350 rounded-full text-sm text-gray-600 focus:outline-none" {...inputProps} />

      <button type="submit" className="absolute top-0 right-0 py-2 pr-4 focus:outline-none">
        <img src={ChevronRightSvg} alt="Enviar" />
      </button>
    </div>
  )
}

export default Input
